import React, { Component } from 'react'
import Axios from 'axios'
import { toast } from 'react-toastify'
import './DirectMatchTruck.css'
import ProgressBar from '../ProgressBar/ProgressBar'
import Loader from '../Loader'
import { Urls } from '../../Urls'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
// global variables for manual entries
var raw_manual = []
// global variables for accepted and rejected entries for truck types
var raw_suggestions = []
// master input
var raw_input = []
export class DirectMatchTruck extends Component {
    constructor(props) {
        super(props)

        this.state = {
            truck_list: [],
            search_list: [],
            input: [],
            select_status: 0,
            loader: false
        }
    }


    // call this function after mounting the component
    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Direct Match Truck',
        //         'module': 'Truck Asset Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Direct Match"
        document.getElementById("header").style.opacity = "0.5"
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "vendor"
        }
        console.log("Master dataset body")
        console.log(body)
        // Call Master API that consolidate vendors data created by user in last screens => direct match(v1) & spell correction(v2)
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.master, body)
                .then(response => {
                    // New body to be used by API
                    console.log("Master for vendor has been executed")
                    body = {}
                    body = {
                        "dataset_id": localStorage.getItem("dataset_id"),
                        "collection_name": "direct_match_trk",
                        "key": "truck"
                    }
                    Axios.post(Urls.dataset.fetch, body, body)
                        .then(response => {
                            console.log(response)
                            this.setState({
                                truck_list: response.data.data,
                                search_list: response.data.search,
                                loader: false
                            }, () => { if (this.state.truck_list.length === 0) { this.props.history.push({ pathname: "/spellCorrectionTruck" }) } })

                            var i;
                            for (i = 0; i < this.state.truck_list.length; i++) {
                                raw_manual.push({ "manual": "" })
                                raw_suggestions.push({ "suggestion": "Accepted" })
                            }
                            raw_input.push(raw_suggestions)
                            raw_input.push(raw_manual)
                            document.getElementById("header").style.opacity = "1"
                        })
                        .catch(error => {
                            this.setState({ loader: false })
                            document.getElementById("header").style.opacity = "1"
                            toast.error("Error while processing your request")
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        })
    }

    selectChangeHandler = (event) => {
        this.setState({
            select_status: 1
        })
        if (event.target.value === "Rejected") {
            document.getElementById(event.target.name).disabled = false
            document.getElementById(event.target.name).required = true
            document.getElementById(event.target.name).style.border = "1px solid royalblue"
        }
        else {
            raw_manual[event.target.name - 1] = { "manual": "" }
            document.getElementById(event.target.name).disabled = true
            document.getElementById(event.target.name).required = false
            document.getElementById(event.target.name).style.border = "none"
        }
        raw_suggestions[event.target.name - 1] = {
            "suggestion": event.target.value
        }

    }

    manualChangeHandler = (event) => {
        raw_manual[event.target.id - 1] = {
            "manual": event.target.value
        }
    }

    submitHandler = (event) => {
        event.preventDefault()
        var emptyRows = []
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
            if (raw_suggestions[i]['suggestion'] === 'Rejected') {
                if (new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    emptyRows.push(raw_manual[i]['manual'])
                    // document.getElementsByName(i).style.border = '1px solid red'
                }
            }
        }

        if (emptyRows.length === 0) {
            // logActivity([
            //     {
            //         'screen': 'Direct Match Truck',
            //         'module': 'Truck Asset Cleaning',
            //         'user_activity': 'data submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            document.getElementById("header").style.opacity = "0.5"
            // check wheteher select handler is pressed or not
            raw_input = []
            raw_input.push(raw_suggestions)
            raw_input.push(raw_manual)
            var body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "collection_name": "direct_match_trk",
                "key": "truck",
                "input": raw_input
            }
            this.setState({
                loader: true
            }, () => {
                Axios.post(Urls.dataset.dump, body)
                    .then(response => {
                        this.setState({ loader: false })
                        document.getElementById("header").style.opacity = "1"
                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                        this.props.history.push({
                            pathname: "/spellCorrectionTruck"
                        })
                    })
                    .catch(error => {
                        this.setState({ loader: false })
                        toast.error("Error while processing your request", this.props.history.push({ pathname: "/directMatchTruck" }))
                    })
            })
        }
        else {
            alert('Please enter truck type')
        }
    }

    goBack = () => this.props.history.push({ pathname: "/spellCorrectionVendor" })

    render() {
        const fetched_trucks = this.state.truck_list
        const search_list = this.state.search_list
        return (
            <div id="header">
                <Loader isLoading={this.state.loader} />
                <div className="container" style={{ "margin-bottom": "5%" }} align="center">
                    <div>
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table cellPadding="20px" id="dc_table" align="center" border="1">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th> Raw Truck Type </th>
                                            <th> Truck Type </th>
                                            <th> Mark as Incorrect </th>
                                            <th> User Input </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            fetched_trucks.map((truck, i) =>
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td> {truck.Truck} </td>
                                                    <td> {truck.Map} </td>
                                                    <td>
                                                        <select className="form-control" name={i + 1} onChange={this.selectChangeHandler} >
                                                            <option value="Accepted"> Accepted </option>
                                                            <option value="Rejected"> Rejected </option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input className="form-control" required list="auto_complete" disabled type="text" name={i + 1} id={i + 1} onChange={this.manualChangeHandler} placeholder="Enter Truck Type" />
                                                        <datalist id="auto_complete">
                                                            {
                                                                search_list.map((truck_type, j) => <option key={j + 1} value={truck_type} > {truck_type} </option>)
                                                            }
                                                        </datalist>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="76%" />
                </div>
            </div>
        )
    }
}

export default DirectMatchTruck
